var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarcaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.9998,
    height: 36,
    rx: 17.9999,
    fill: "#855DCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5684 8.88281V11.5455H8.16016L9.01223 14.1017H9.54477V24.3266C9.00666 24.5783 8.97419 24.921 9.01223 25.6047C8.27575 25.8287 8.27251 26.2052 8.26678 26.8699L8.26667 26.8828H14.7637C14.7826 26.1552 14.7299 25.8039 14.1247 25.6047C14.1553 24.8046 14.0098 24.5205 13.3791 24.3266V18.6816C15.1897 12.7171 20.9412 13.7822 22.3258 18.6816V24.3266C21.8854 24.535 21.7853 24.8401 21.7933 25.6047C21.1591 25.9116 21.1175 26.2401 21.1542 26.8828H27.6513C27.6807 26.2672 27.6513 25.8177 26.9057 25.6047C26.9302 25.0033 26.8863 24.6894 26.3732 24.3266V14.1017H27.0122L27.7578 11.5455H24.243V8.88281H11.5684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarcaster);
export default __webpack_public_path__ + "static/media/farcaster.5d4dd0aa1346b2b449d2036e68646d54.svg";
export { ForwardRef as ReactComponent };